import { CHANGE_GENERAL_STORE_SETTINGS, CLOSE_ARAG_USER_SETTINGS_MENU, OPEN_ARAG_USER_SETTINGS_MENU } from "./index";

export function openAragUserSettingsMenu(payload) {
    return {
        type: OPEN_ARAG_USER_SETTINGS_MENU,
        payload: payload
    }
}

export function closeAragUserSettingsMenu(payload) {
    return {
        type: CLOSE_ARAG_USER_SETTINGS_MENU,
        payload: payload
    }
}

export function changeGeneralStoreSettings(payload) {
    return {
        type: CHANGE_GENERAL_STORE_SETTINGS,
        payload: payload
    }
}